import React, { useState } from "react";
import { Filter, ChevronDown, BadgeCheck } from "lucide-react";
import { GOLD } from "../constants/theme";

// Collapsible "More filters" panel — currently houses Coach filtering
// (grouped BAM Staff / Masterclass / Community). Designed to be extended
// with extra filter dimensions (duration range, pinned-by-admin, etc.).
export function MoreFilters({ C, dark, coaches, selectedCoachIds, setSelectedCoachIds }) {
  const [open, setOpen] = useState(false);

  const togglePick = (id) => {
    const next = new Set(selectedCoachIds);
    if (next.has(id)) next.delete(id); else next.add(id);
    setSelectedCoachIds(next);
  };

  const clear = () => setSelectedCoachIds(new Set());
  const selectedCount = selectedCoachIds.size;

  const Group = ({ title, list }) => {
    if (!list || list.length === 0) return null;
    return (
      <div style={{marginBottom:12}}>
        <div style={{fontSize:9,fontWeight:800,color:C.textDim,letterSpacing:1.2,textTransform:"uppercase",marginBottom:8}}>{title}</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {list.map(c => {
            const on = selectedCoachIds.has(c.id);
            return (
              <button key={c.id} onClick={()=>togglePick(c.id)}
                style={{display:"inline-flex",alignItems:"center",gap:6,padding:"5px 11px",borderRadius:16,fontSize:11.5,fontWeight:700,cursor:"pointer",
                  border:`1px solid ${on?GOLD:C.border}`,
                  background:on?GOLD:"transparent",
                  color:on?"#111":C.textMid,transition:"all .15s"}}>
                {c.name}
                {c.isVerified && <BadgeCheck size={11} color={on ? "#111" : GOLD}/>}
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div style={{marginBottom:16}}>
      <button onClick={()=>setOpen(o=>!o)}
        style={{display:"inline-flex",alignItems:"center",gap:8,padding:"7px 14px",borderRadius:9,
          background:open?`${GOLD}18`:"transparent",border:`1px solid ${open||selectedCount>0?GOLD:C.border}`,
          color:open||selectedCount>0?GOLD:C.textMid,
          fontSize:12,fontWeight:700,cursor:"pointer",transition:"all .15s"}}>
        <Filter size={13}/>
        More filters
        {selectedCount > 0 && (
          <span style={{fontSize:10,fontWeight:800,color:"#111",background:GOLD,padding:"1px 7px",borderRadius:10,lineHeight:1.4}}>
            {selectedCount}
          </span>
        )}
        <ChevronDown size={13} style={{transform:open?"rotate(180deg)":"rotate(0)",transition:"transform .15s"}}/>
      </button>
      {open && (
        <div className="bam-menu-in from-t" style={{marginTop:10,padding:"14px 16px",borderRadius:12,
          background:C.cardGradient,border:`1px solid ${C.cardBorder}`,
          boxShadow:dark?"0 8px 32px rgba(0,0,0,0.35)":"0 4px 14px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:10,fontWeight:800,color:GOLD,letterSpacing:1.2,textTransform:"uppercase",marginBottom:10,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span>Filter by coach</span>
            {selectedCount > 0 && (
              <button onClick={clear}
                style={{fontSize:10,fontWeight:700,color:C.textDim,background:"transparent",border:"none",cursor:"pointer"}}>
                Clear
              </button>
            )}
          </div>
          <Group title="By Any Means Coaches" list={coaches?.staff}/>
          <Group title="Masterclass Coaches" list={coaches?.masterclass}/>
          <Group title="Community Coaches" list={coaches?.community}/>
          {(!coaches?.staff?.length && !coaches?.masterclass?.length && !coaches?.community?.length) && (
            <div style={{fontSize:12,color:C.textDim}}>No coaches loaded yet.</div>
          )}
        </div>
      )}
    </div>
  );
}

// BAM vs All source toggle — small pill row next to or above filter chips.
export function VideoSourceToggle({ value, onChange, C, counts }) {
  const tabs = [
    { id: "bam", label: `BAM videos${counts?.bam != null ? ` (${counts.bam})` : ""}` },
    { id: "all", label: `All videos${counts?.all != null ? ` (${counts.all})` : ""}` },
  ];
  return (
    <div className="bam-source-toggle" style={{display:"flex",gap:4,padding:3,background:"rgba(255,255,255,0.03)",borderRadius:10,border:`1px solid ${C.border}`,width:"fit-content"}}>
      {tabs.map(t => {
        const on = value === t.id;
        return (
          <button key={t.id} onClick={()=>onChange(t.id)}
            style={{padding:"6px 13px",borderRadius:7,fontSize:11.5,fontWeight:800,letterSpacing:.3,cursor:"pointer",
              border:"none",
              background:on?GOLD:"transparent",
              color:on?"#111":C.textMid,transition:"all .15s"}}>
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export default MoreFilters;
